<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import vue2Dropzone from "vue2-dropzone";
import { registrar, ACCIONES } from "@/services/bitacora";
import { empleadoComputed } from "@/state/helpers";

export default {
  page: {
    title: "Sesiones de reconstruccion",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    'vue-dropzone': vue2Dropzone,
  },
  data() {
    return {
      searchQuery: '',
      img: null,
      autor: null,
      ciudad: null,
      fecha: null,
      lugar: false,
      titulo: null,
      options: [],
      dataSesiones: [],
      editarSesion: false,
      sesionSelected: null,
      agregarSesion: false,
      filterType: "todas",
      filterOptions: [
        { value: "todas", text: "Todas las sesiones" },
        { value: "conocimiento", text: "Conocimiento" },
        { value: "capacitacion", text: "Capacitación empresarial" },
        { value: "artistas", text: "Artistas" },
      ],
      nuevaSesion: {
        autor: null,
        ciudad: null,
        fecha: null,
        lugar: null,
        titulo: null,
        activo: false,
        descripcion: null,
        video: null,
        spotify: null,
        instagram: null,
        facebook: null,
        img: null,
        type: "conocimiento",
      },
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 3.5,
        headers: { "My-Awesome-Header": "header value" },
        acceptedFiles: "image/*",
      },
      // PAGINACIÓN
      currentPage: 1,
      perPage: 9,
    };
  },
  computed: {
    ...empleadoComputed,
    filteredSesiones() {
      let filtered = this.dataSesiones;

      if (this.filterType !== "todas") {
        filtered = filtered.filter((s) => s.type === this.filterType);
      }

      if (this.searchQuery) {
        const lowerCaseQuery = this.searchQuery.toLowerCase();
        filtered = filtered.filter(s =>
          (s.titulo && s.titulo.toLowerCase().includes(lowerCaseQuery)) ||
          (s.autor && s.autor.toLowerCase().includes(lowerCaseQuery))
        );
      }

      return filtered.slice().sort((a, b) => {
        const dateA = a.timestamp ? a.timestamp.toMillis() : 0;
        const dateB = b.timestamp ? b.timestamp.toMillis() : 0;
        return dateB - dateA;
      });
    },
    paginatedSesiones() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredSesiones.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredSesiones.length / this.perPage) || 1;
    }
  },
  watch: {
    filteredSesiones() {
      // Si la página actual se queda sin elementos, vuelve a la primera página
      if ((this.currentPage - 1) * this.perPage >= this.filteredSesiones.length) {
        this.currentPage = 1;
      }
    }
  },
  methods: {
    openEdit(data) {
      this.editarSesion = true;
      this.sesionSelected = data;
    },
    descargarCSV() {
      const sesionesParaExportar = this.filteredSesiones;
      if (sesionesParaExportar.length === 0) {
        Swal.fire("Sin datos", "No hay sesiones para exportar.", "info");
        return;
      }
      const cabeceras = [
        "ID",
        "Título",
        "Autor",
        "Fecha de Registro",
        "Tipo",
        "Ciudad",
        "Lugar",
        "Descripción",
        "Activo",
        "Video (Vimeo ID)",
        "Spotify",
        "Facebook",
        "Instagram",
      ];
      const filas = sesionesParaExportar.map(s => [
        s.id,
        s.titulo,
        s.autor,
        this.formatTimestamp(s.timestamp),
        s.type,
        s.ciudad,
        s.lugar,
        s.descripcion,
        s.activo ? 'Si' : 'No',
        s.video,
        s.spotify,
        s.facebook,
        s.instagram
      ]);
      const escaparValor = (valor) => {
        if (valor === null || valor === undefined) return '';
        let valorStr = String(valor);
        if (valorStr.includes(',') || valorStr.includes('"') || valorStr.includes('\n')) {
          valorStr = `"${valorStr.replace(/"/g, '""')}"`;
        }
        return valorStr;
      };
      const contenidoCSV = [
        cabeceras.join(','),
        ...filas.map(fila => fila.map(escaparValor).join(','))
      ].join('\n');
      const blob = new Blob(['\uFEFF' + contenidoCSV], { type: 'text/csv;charset=utf-8;' });
      const enlace = document.createElement("a");
      const url = URL.createObjectURL(blob);
      enlace.setAttribute("href", url);
      enlace.setAttribute("download", "reporte_sesiones.csv");
      enlace.style.visibility = 'hidden';
      document.body.appendChild(enlace);
      enlace.click();
      document.body.removeChild(enlace);
    },
    deleteSesion(id) {
      Swal.fire({
        title: "¿Estas seguro de eliminar esta sesión?",
        text: "Esta sesión se eliminará permanentemente.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Borrar",
      }).then((result) => {
        if (result.value) {
          const antes = this.dataSesiones.find((s) => s.id === id);
          firebase
            .firestore()
            .collection("sesiones")
            .doc(id)
            .delete()
            .then(() => registrar({
              accion: ACCIONES.ELIMINAR,
              coleccion: "sesiones",
              docId: id,
              descripcion: antes ? antes.titulo : id,
              antes,
            }))
            .then(() => {
              Swal.fire(
                "Eliminado",
                "Esta sesión ha sido eliminada con exito",
                "success"
              );
              this.fetchSesiones();
            })
            .catch((error) => {
              alert("Error removing document: ", error);
            });
        }
      });
    },
    GuardarEdicionSesion() {
      if (!this.sesionSelected) return;
      let json = {
        autor: this.sesionSelected.autor,
        ciudad: this.sesionSelected.ciudad,
        lugar: this.sesionSelected.lugar,
        titulo: this.sesionSelected.titulo,
        activo: this.sesionSelected.activo,
        descripcion: this.sesionSelected.descripcion,
        fecha: this.sesionSelected.fecha,
        video: this.sesionSelected.video,
        spotify: this.sesionSelected.spotify,
        facebook: this.sesionSelected.facebook,
        instagram: this.sesionSelected.instagram,
        img: this.sesionSelected.img,
        type: this.sesionSelected.type,
      };
      Swal.fire({
        title: "¿Estas seguro de editar esta sesión?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, editar",
      }).then((result) => {
        if (result.value) {
          firebase
            .firestore()
            .collection("sesiones")
            .doc(this.sesionSelected.id)
            .update(json)
            .then(() => registrar({
              accion: ACCIONES.EDITAR,
              coleccion: "sesiones",
              docId: this.sesionSelected.id,
              descripcion: json.titulo,
              antes: this.dataSesiones.find((s) => s.id === this.sesionSelected.id),
              despues: json,
            }))
            .then(() => {
              Swal.fire(
                "Actualizado",
                "La sesión ha sido actualizada con exito",
                "success"
              );
              this.editarSesion = false;
              this.fetchSesiones();
            })
            .catch((error) => {
              alert("Error actualizando documento: " + error);
            });
        }
      });
    },
    GuardarSesion() {
      firebase
        .firestore()
        .collection("sesiones")
        .add({
          autor: this.nuevaSesion.autor,
          ciudad: this.nuevaSesion.ciudad,
          lugar: this.nuevaSesion.lugar,
          titulo: this.nuevaSesion.titulo,
          activo: this.nuevaSesion.activo,
          descripcion: this.nuevaSesion.descripcion,
          fecha: this.nuevaSesion.fecha,
          video: this.nuevaSesion.video,
          img: this.nuevaSesion.img,
          type: this.nuevaSesion.type,
          spotify: this.nuevaSesion.spotify,
          facebook: this.nuevaSesion.facebook,
          instagram: this.nuevaSesion.instagram,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then((ref) => registrar({
          accion: ACCIONES.CREAR,
          coleccion: "sesiones",
          docId: ref.id,
          descripcion: this.nuevaSesion.titulo,
          despues: this.nuevaSesion,
        }))
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Tu registro ha sido guardado",
            showConfirmButton: false,
            timer: 1500,
          });
          this.agregarSesion = false;
          this.fetchSesiones();
        })
        .catch((error) => {
          alert(error);
        });
    },
    previewFile(file, response) {
      this.file = response.files.file;
      let storageRef = firebase.storage().ref(`sesiones/${uuidv4()}.png`);
      storageRef
        .putString(this.file.split(",")[1], "base64")
        .then((snapshot) => {
          const downloadUrl = storageRef.getDownloadURL();
          downloadUrl.then((url) => {
            if (this.agregarSesion) {
              this.nuevaSesion.img = url;
            } else if (this.editarSesion) {
              this.sesionSelected.img = url;
            }
          });
        })
        .catch((error) => {
          console.log(
            "🚀 ~ file: contenidoEmpresas.vue ~ line 84 ~ .putString ~ error",
            error
          );
        });
    },
    formatTimestamp(ts) {
      if (!ts) return 'N/A';
      let date;
      if (ts.toDate) {
        date = ts.toDate();
      } else if (ts.seconds) {
        date = new Date(ts.seconds * 1000);
      } else {
        return 'Fecha inválida';
      }
      const meses = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ];
      const dia = date.getDate();
      const mes = meses[date.getMonth()];
      const anio = date.getFullYear();
      return `${dia}/${mes}/${anio}`;
    },
    fetchSesiones() {
      firebase
        .firestore()
        .collection("sesiones")
        .get()
        .then((querySnapshot) => {
          const array = [];
          querySnapshot.forEach((documentSnapshot) => {
            array.push({
              id: documentSnapshot.id,
              ...documentSnapshot.data()
            });
          });
          this.dataSesiones = array;
        });
    }
  },
  mounted() {
    this.fetchSesiones();
  },
};
</script>

<template>
  <Layout>
    <div class="mb-4">
      <img :src="require('@/assets/images/recnet-header.png')" alt="Sesiones de reconstrucción"
        class="img-fluid w-100 rounded shadow-sm"
        style="max-height: 260px; object-fit: cover; object-position: center;" />
    </div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="row d-flex justify-content-between align-items-center p-3">
            <div class="col-md-6">
              <b-form-group label="Filtrar por tipo:" label-for="filterType" class="mb-0">
                <b-form-select id="filterType" v-model="filterType" :options="filterOptions" class="w-auto">
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-3 d-flex ">
              <b-form-group label="Agregar nueva sesión:" label-for="filterType" class="mb-0">
                <button v-if="puedeEditar" @click="agregarSesion = true" type="button" class="btn btn-success">
                  <i class="mdi mdi-pencil"></i>
                </button>
              </b-form-group>
            </div>
            <div class="col-md-3 d-flex">
              <b-form-group label="Descargar CSV de sesiones:" label-for="filterType" class="mb-0">
                <b-button variant="info" @click="descargarCSV">
                  <i class="mdi mdi-download"></i>
                </b-button>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="d-flex justify-content-between align-items-center p-3 flex-wrap gap-3">
                  <b-form-group label="Buscar:" label-for="searchInput" class="mb-0 w-100">
                    <b-form-input id="searchInput" v-model="searchQuery" placeholder="Buscar por título o autor..."
                      style="min-width: 220px;">
                    </b-form-input>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-centered mb-0 table-hover table-nowrap mt-2">
              <thead class="thead-light">
                <tr>

                  <th>Título</th>
                  <th>Autor</th>
                  <th>Fecha</th>
                  <th>Tipo</th>
                  <th>Ver más</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in paginatedSesiones" :key="data.id">
                  <td>{{ data.titulo }}</td>
                  <td>{{ data.autor }}</td>
                  <td>{{ formatTimestamp(data.timestamp) }}</td>
                  <td>
                    <span class="badge text-uppercase" :class="{
                      'badge-warning': data.type === 'artistas',
                      'badge-primary': data.type === 'conocimiento',
                      'badge-success': data.type === 'capacitacion'
                    }">
                      {{ data.type }}
                    </span>
                  </td>
                  <td>
                    <button type="button" class="btn btn-success btn-sm" @click="openEdit(data)">
                      <i class="mdi mdi-square-edit-outline ms-2"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="filteredSesiones.length === 0">
                  <td colspan="5" class="text-center text-muted py-4">
                    No hay sesiones que coincidan con tu búsqueda.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- PAGINACIÓN -->
          <div class="d-flex justify-content-center my-3">
            <b-pagination v-model="currentPage" :total-rows="filteredSesiones.length" :per-page="perPage"
              :aria-controls="'tabla-sesiones'" align="center" size="md" pills></b-pagination>
          </div>
        </div>
      </div>
      <!-- ... (modales igual) ... -->
      <b-modal v-model="agregarSesion" id="modal-nueva-sesion" size="lg" title="Nueva Sesión de reconstrucción "
        centered>
        <b-form @submit.prevent="GuardarSesion">
          <b-row>
            <b-col md="12">
              <b-form-group label="Título">
                <b-form-input v-model="nuevaSesion.titulo" required />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Ciudad">
                <b-form-input v-model="nuevaSesion.ciudad" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Autor">
                <b-form-input v-model="nuevaSesion.autor" required />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Lugar">
                <b-form-input v-model="nuevaSesion.lugar" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Estado">
                <b-form-select v-model="nuevaSesion.activo"
                  :options="[{ value: true, text: 'Activo' }, { value: false, text: 'Inactivo' }]" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Tipo">
                <b-form-select v-model="nuevaSesion.type" :options="[
                  { value: 'conocimiento', text: 'Conocimiento' },
                  { value: 'capacitacion', text: 'Capacitación empresarial' },
                  { value: 'artistas', text: 'Artistas' }
                ]" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group label="Descripción">
            <b-form-textarea v-model="nuevaSesion.descripcion" rows="2" />
          </b-form-group>
          <b-row>
            <b-col md="4">
              <b-form-group label="Facebook">
                <b-form-input v-model="nuevaSesion.facebook" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Instagram">
                <b-form-input v-model="nuevaSesion.instagram" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Spotify">
                <b-form-input v-model="nuevaSesion.spotify" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Vimeo ID">
                <b-form-input v-model="nuevaSesion.video" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <div v-if="nuevaSesion.video && sesionSelected" class="mt-2">
                <label class="mb-1">Vista previa del video</label>
                <div class="card p-1 border shadow-none">
                  <div class="ratio ratio-4x3">
                    <iframe class="embed-responsive-item"
                      :src="`https://player.vimeo.com/video/${sesionSelected.video}`" allowfullscreen></iframe>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Subir portada de la sesión">
                <vue-dropzone id="dropzone-nuevo" ref="myVueDropzoneNuevo" :use-custom-slot="true" :options="{
                  ...dropzoneOptions,
                  thumbnailWidth: 100,
                  maxThumbnailFilesize: 1.5
                }" @vdropzone-success="previewFile" style="max-width: 400px; margin: 0 auto;">
                  <div class="dropzone-custom-content">
                    <div class="mb-1">
                      <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                    </div>
                    <h6 style='font-size: 1rem;'>Arrastre la imagen aquí o haga clic para cargar.</h6>
                  </div>
                </vue-dropzone>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Vista previa de la portada">
                <div v-if="nuevaSesion.img" class="mt-2 text-center">
                  <img :src="nuevaSesion.img" alt="Portada" class="img-thumbnail" style="max-width: 260px;" />
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-center gap-2 mt-4">
            <b-button type="submit" variant="success">Guardar</b-button>
          </div>
        </b-form>
      </b-modal>
      <!--INICIO MODAL EDITAR SESION-->
      <b-modal v-model="editarSesion" id="modal-editar-sesion" size="lg" title="Editar Sesión de reconstrucción"
        centered>
        <b-form v-if="sesionSelected" @submit.prevent="GuardarEdicionSesion">
          <b-row>
            <b-col md="6">
              <b-form-group label="Título" label-class="fw-bold">
                <b-form-input v-model="sesionSelected.titulo" required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Fecha de la sesión">
                <div class="form-control-plaintext fw-bold">
                  {{ formatTimestamp(sesionSelected.timestamp) }}
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Autor">
                <b-form-input v-model="sesionSelected.autor" required />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Ciudad">
                <b-form-input v-model="sesionSelected.ciudad" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Lugar">
                <b-form-input v-model="sesionSelected.lugar" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Estado">
                <b-form-select v-model="sesionSelected.activo"
                  :options="[{ value: true, text: 'Activo' }, { value: false, text: 'Inactivo' }]" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Tipo">
                <b-form-select v-model="sesionSelected.type" :options="[
                  { value: 'conocimiento', text: 'Conocimiento' },
                  { value: 'capacitacion', text: 'Capacitación empresarial' },
                  { value: 'artistas', text: 'Artistas' }
                ]" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group label="Descripción">
            <b-form-textarea v-model="sesionSelected.descripcion" rows="5" />
          </b-form-group>
          <b-row>
            <b-col md="4">
              <b-form-group label="Facebook">
                <b-form-input v-model="sesionSelected.facebook" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Instagram">
                <b-form-input v-model="sesionSelected.instagram" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Spotify">
                <b-form-input v-model="sesionSelected.spotify" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Vimeo ID">
                <b-form-input v-model="sesionSelected.video" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <div v-if="sesionSelected.video" class="mt-2">
                <label class="mb-1">Vista previa del video</label>
                <div class="card p-1 border shadow-none">
                  <div class="ratio ratio-4x3">
                    <iframe class="embed-responsive-item"
                      :src="`https://player.vimeo.com/video/${sesionSelected.video}`" allowfullscreen></iframe>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Subir portada de la sesión">
                <vue-dropzone id="dropzone-editar" ref="myVueDropzoneEditar" :use-custom-slot="true" :options="{
                  ...dropzoneOptions,
                  thumbnailWidth: 100,
                  maxThumbnailFilesize: 1.5
                }" @vdropzone-success="previewFile" style="max-width: 400px; margin: 0 auto;">
                  <div class="dropzone-custom-content">
                    <div class="mb-1">
                      <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                    </div>
                    <h6 style='font-size: 1rem;'>Arrastre la imagen aquí o haga clic para cargar.</h6>
                  </div>
                </vue-dropzone>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Vista previa de la portada">
                <div v-if="sesionSelected.img" class="mt-2 text-center">
                  <img :src="sesionSelected.img" alt="Portada" class="img-thumbnail" style="max-width: 260px;" />
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-center mt-4">
            <b-button v-if="puedeEditar" type="submit" variant="success" class="mx-2">Guardar</b-button>
            <b-button v-if="puedeEditar" variant="danger" class="mx-2"
              @click="deleteSesion(sesionSelected.id)">Eliminar</b-button>
          </div>
        </b-form>
      </b-modal>
    </div>
  </Layout>
</template>
